<template>
    <Breadcrumbs main="Bonus Ui" title="Breadcrumb" />
    <div class="container-fluid">
        <div class="row">
            <defaultBreadcrumb />
            <dividersBreadcrumbs />
            <iconsBreadcrumb />
            <navBreadcrumb />
            <coloredNavigation />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const defaultBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/defaultBreadcrumb.vue"))
const dividersBreadcrumbs = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/dividersBreadcrumbs.vue"))
const iconsBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/iconsBreadcrumb.vue"))
const navBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/navBreadcrumb.vue"))
const coloredNavigation = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/coloredNavigation.vue"))
</script>